<template>
  <div class="ts-hero">
    <v-carousel
      v-model="actual"
      height="auto"
      cycle
      interval="15000"
      show-arrows
      delimiter-icon="mdi-circle"
      hide-delimiter-background
      class="ts-hero-carousel"
    >
      <v-carousel-item key="preregistro-silvestre">
        <div class="ts-hero-slide" @click="verPreregistro('silvestre-san-cristobal')">
          <v-img
            src="/images/preregistro/silvestre_san_cristobal/1000x500.png"
            lazy-src="/images/placeholder-banner.jpg"
            class="ts-hero-img"
            contain
          ></v-img>
          <div class="ts-hero-overlay">
            <button type="button" class="ts-btn-gold ts-hero-cta" @click.stop="verPreregistro('silvestre-san-cristobal')">
              Comprar boletas <i class="material-icons">chevron_right</i>
            </button>
          </div>
        </div>
      </v-carousel-item>
      <v-carousel-item :key="index" v-for="(item, index) in items">
        <div class="ts-hero-slide" @click="redirect ? verEvento(item.imagen.slug) : ''">
          <v-img
            :src="bannerUrl(item.imagen)"
            lazy-src="/images/placeholder-banner.jpg"
            class="ts-hero-img"
            contain
          ></v-img>
          <div class="ts-hero-overlay" v-if="redirect">
            <button type="button" class="ts-btn-gold ts-hero-cta" @click.stop="verEvento(item.imagen.slug)">
              Comprar boletas <i class="material-icons">chevron_right</i>
            </button>
          </div>
        </div>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>
<script>
export default {
  props: ['items', 'redirect'],
  data() {
    return {
      actual: 0,
    };
  },
  methods: {
    bannerUrl(evento) {
      const banner = evento.imagens.find(img => img.nombre.includes('banner'));
      return banner ? banner.url : evento.imagens[0].url;
    },
    verEvento(id) {
      this.$router.push({ name: 'evento', params: { evento: id } });
    },
    verPreregistro(evento) {
      this.$router.push({ name: 'preregistro', params: { evento: evento } });
    },
  },
};
</script>
<style>
.ts-hero {
  background: #0b0b0b;
}
.ts-hero-slide {
  position: relative;
  cursor: pointer;
}
.ts-hero-img {
  width: 100%;
}
.ts-hero-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 6% 48px;
  pointer-events: none;
}
.ts-hero-cta {
  pointer-events: auto;
}
.ts-btn-gold {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: linear-gradient(180deg, #f6dc8c 0%, #d4a537 55%, #b8862a 100%);
  color: #1a1a1a !important;
  font-family: 'Oswald', sans-serif !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  border: 0;
  border-radius: 999px;
  padding: 12px 34px;
  font-size: 20px;
  box-shadow: 0 6px 18px rgba(212, 165, 55, .35);
  transition: transform .2s, box-shadow .2s;
  cursor: pointer;
}
.ts-btn-gold:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(212, 165, 55, .5);
}
.ts-hero-carousel .v-window__prev,
.ts-hero-carousel .v-window__next {
  background: rgba(0, 0, 0, .45);
  border: 1px solid rgba(255, 255, 255, .6);
}
.ts-hero-carousel .v-carousel__controls {
  height: 36px;
}
.ts-hero-carousel .v-carousel__controls .v-btn {
  color: #fff !important;
  opacity: .6;
}
.ts-hero-carousel .v-carousel__controls .v-btn--active {
  opacity: 1;
}
.ts-hero-carousel .v-carousel__controls .v-icon {
  font-size: 12px !important;
}
@media (max-width: 767px) {
  .ts-hero-overlay {
    padding-bottom: 40px;
  }
  .ts-btn-gold.ts-hero-cta {
    font-size: 14px;
    padding: 8px 20px;
  }
}
</style>
